import { API } from '@/api';

export const createFolder = data => API.post('/folders/', data);
export const getFolderById = (id = '', query = {}, sorting = 'desc') => {
  const q = Object.keys(query)
    .map(key => `${key}=${query[key]}`)
    .join('&');

  return API.get(`/folders/?order=${sorting === 'desc' ? '-': ''}created_at${id ? '&folder_id=' + id : ''}${q ? '&' + q : ''}`);
};
export const getRootFolder = (query = {}, sorting = 'desc') => {
  // const q = Object.keys(query)
  //   .map(key => `${key}=${query[key]}`)
  //   .join('&');
  //
  // return API.get(`/folders?parent_id=0&skip=0&order=-created_at&${q}`);
  return getFolderById('', query, sorting)
};
export const updateFolder = (data, id) => API.put(`/folders/${id}/`, data);
export const deleteFolder = id => API.delete(`/folders/${id}/`);
export const searchFolder = q => API.get(`/search/?search_str=${q}`);
export const getFiltersForFolder = id => API.get(`/folders/${id}/filters/`);
